export const isValidOrderName = (orderName: string): boolean => {
  return orderName.length > 0;
};
